import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Pages.css';
import './css/Fonts.css';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ClientLogos from './ClientLogos';
import dataLaptop from './img/data_laptop.jpg';

function About() {
  return (
    <div className="page">
      <header className="page-header">
        <Container>
          <p className="page-eyebrow">About</p>
          <h1 className="page-title">The right data. The right metrics. The best decisions.</h1>
          <p className="page-lead">
            InfoRight helps mining companies integrate and use information from separate, disparate
            systems they already own. We help you collect and use the right data to measure and
            improve end-to-end processes, from extraction to handling to processing and beyond.
          </p>
        </Container>
      </header>

      <Container className="page-section">
        <Row className="align-items-center g-5">
          <Col lg={6}>
            <h2 className="section-title">Why we exist</h2>
            <p className="section-lead">
              Mining operations rarely suffer from a shortage of data. They suffer because the data
              lives in systems that were never meant to talk to each other — and the gaps get
              covered by spreadsheets or paper solutions.
            </p>
            <p className="section-lead">
              That works right up until it doesn't. Version control becomes a genuinely costly
              problem, and decisions get made on whichever copy someone happened to open. We replace
              those workarounds with real applications built on the systems you already run.
            </p>
          </Col>
          <Col lg={6}>
            <img className="about-image" src={dataLaptop} alt="Working with operational data" />
          </Col>
        </Row>
      </Container>

      <section className="engagement">
        <Container>
          <h2 className="section-title text-center">How we work</h2>
          <Row className="g-4 mt-2">
            <Col md={4}>
              <div className="step-card">
                <h3 className="step-title">Built on what you own</h3>
                <p className="step-text">
                  We integrate with your existing project, financial, and operational systems rather
                  than asking you to replace them.
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className="step-card">
                <h3 className="step-title">Results quickly</h3>
                <p className="step-text">
                  We work with you to achieve meaningful results as quickly as possible, not after a
                  multi-year transformation program.
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className="step-card">
                <h3 className="step-title">End to end</h3>
                <p className="step-text">
                  From extraction to handling to processing and beyond, we measure the whole process
                  rather than one convenient slice of it.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <ClientLogos />

      <section className="cta-band">
        <Container className="text-center">
          <h2 className="cta-title">Let's get your data working</h2>
          <Button variant="" as={Link} to="/contact" className="btn-light-ir">
            Contact Us
          </Button>
        </Container>
      </section>
    </div>
  );
}

export default About;
